/* eslint-disable react/no-unescaped-entities */
import Link from "next/link";
import { Container, Row, Col } from "react-grid-system";
import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";

const FeatherMCUs = () => (
  <>
    <Container className="landingGridContainer">
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs
            links={[
              { name: "Docs", url: "/docs" },
              { name: "Feather MCUs", url: "/feather-mcus" },
            ]}
          />
          <h1>Feather MCUs</h1>
          <p>The hub for documentation on Blues Cygnet and Blues Swan.</p>
        </Col>
      </Row>

      <h2>Blues Cygnet</h2>
      <p>
        <Link href="https://shop.blues.com/collections/feather-mcu/products/cygnet">
          Cygnet
        </Link>
        &nbsp;is a low-cost Feather-compatible STM32L433-based microcontroller
        board designed to accelerate the development and deployment of
        battery-powered solutions.
      </p>
      <Link href="/feather-mcus/cygnet">
        <img
          alt="Blues Cygnet"
          className="mcu-image"
          src={ImgSrc("/images/hardware/cygnet/cygnet-front.png")}
        />
      </Link>

      <Row>
        <Col>
          <div className="landing-page-link-list">
          <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/library-books.svg")}
              />
              <h4>Cygnet Quickstart</h4>
              <p>
                The place to start. This guide will help you start developing on
                the Cygnet with Arduino, using PlatformIO.
              </p>
              <TrackedLink
                href="/quickstart/cygnet-quickstart"
                className="landingLink"
              >
                Read guide
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/notecard-solutions.svg")}
              />
              <h4>Cygnet Datasheet</h4>
              <p>
                View detailed documentation on the Cygnet's specifications, pin
                information, package configuration, and more.
              </p>
              <TrackedLink
                href="/datasheets/cygnet-datasheet/cygnet-v1-2"
                className="landingLink"
              >
                Visit datasheet
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/firmware-libraries.svg")}
              />
              <h4>Using Arduino IDE with Cygnet</h4>
              <p>
                Learn how to work with Cygnet in Arduino IDE, including how to
                install the board and flash firmware.
              </p>
              <TrackedLink
                href="/feather-mcus/cygnet/using-arduino-ide-with-cygnet"
                className="landingLink"
              >
                Read guide
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>

      <hr />

      <Row>
        <Col>
          <h2>Blues Swan</h2>
          <p>
            <Link href="https://shop.blues.com/collections/feather-mcu/products/swan">
              Swan
            </Link>
            &nbsp; is a powerful Feather-compatible STM32L4R5-based
            microcontroller board. With 2MB of flash and 640KB of RAM, the Swan
            is ready for the demands of real-world applications.
          </p>
          <Link href="/feather-mcus/swan">
            <img
              alt="Blues Swan"
              className="mcu-image"
              src={ImgSrc("/images/hardware/swan/swan-front-v3.0.png")}
            />
          </Link>

          <div className="landing-page-link-list">
            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/library-books.svg")}
              />
              <h4>Swan Quickstart</h4>
              <p>
                The place to start. This guide will help you start developing on
                the Swan with Arduino, using PlatformIO.
              </p>
              <TrackedLink
                href="/quickstart/swan-quickstart"
                className="landingLink"
              >
                Read guide
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/notecard-solutions.svg")}
              />
              <h4>Swan Datasheet</h4>
              <p>
                View detailed documentation on the Swan's specifications, pin
                information, package configuration, and more.
              </p>
              <TrackedLink
                href="/datasheets/swan-datasheet/swan-v3-0"
                className="landingLink"
              >
                Visit datasheet
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/firmware-libraries.svg")}
              />
              <h4>Using Arduino IDE with Swan</h4>
              <p>
                Learn how to work with Swan in Arduino IDE, including how to
                install the board and flash firmware.
              </p>
              <TrackedLink
                href="/feather-mcus/swan/using-arduino-ide-with-swan"
                className="landingLink"
              >
                Read guide
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/precision-manufacturing.svg")}
              />
              <h4>Using CircuitPython with Swan</h4>
              <p>Learn how to program the Swan with CircuitPython.</p>
              <TrackedLink
                href="/feather-mcus/swan/using-circuitpython-with-swan"
                className="landingLink"
              >
                Read guide
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
    <style jsx>
      {`
        .mcu-image {
          margin-top: 3rem;
          height: 150px;
        }
      `}
    </style>
  </>
);

export default FeatherMCUs;
